import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="M 5 3 C 3.9 3 3 3.9 3 5 L 3 19 C 3 20.1 3.9 21 5 21 L 19 21 C 20.1 21 21 20.1 21 19 L 21 5 C 21 3.9 20.1 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 9 7 L 9.0039062 7.0097656 C 9.0039062 7.0887656 9.0018125 16.993047 9.0078125 16.998047 C 9.0138125 17.003047 10 16.75 11 16.75 L 11 11.875 L 13 16.75 C 14 16.75 14.986188 17.003047 14.992188 16.998047 C 14.998187 16.994047 14.996094 7.0078125 14.996094 7.0078125 L 13 7 L 13 12.001953 C 12.001 9.5009531 11 7 11 7 L 9 7 z" />,
  'NetflixOutlined'
);
